<template>
  <RF-Dialog
  :cpntStatus='statusGeral'
  :cpntTitulo='"Novo Usuário de Integração"'
  :cpntLargura='"600px"'

  :cpntOnFecharDialog='cpntFecharFormulario'>
    <template slot='conteudo' v-if="Object.keys(formulario).length >= 1">
      <RF-Formulario :data-time='time'
        style="margin-top: 30px; text-align: center;"

        :cpntTime='time'
        :cpntId='formulario.id' 
        :cpntStatus='formulario.status'
        :cpntField='formulario.field'
        :cpntUltAlt='formulario.ult_alt'
        :cpntTabIndexFieldGeral='formulario.tabIndexFieldGeral'
        :cpntTabIndexButtonGeral='formulario.tabIndexButtonGeral'
        :ref='formulario.id'
      ></RF-Formulario>

      <div class="con-config-user-novo-alerta">
        Prezado Cliente, a inclusão deste usuário criará um chamado e acrescentará o valor de um usuário
        <br/>
        <br/>
        adicional/mês a partir da próxima fatura. Não será possível remover este usuário pelo período de 30 dias corridos.
        <br/>
        <br/>
        Após clicar em Aceito, inserir! o usuário já estará disponível para utilização.
        <br/>
        <br/>

        <template v-for='(button, index) in formulario.buttons'>
          <RF-Button :key="index"
            :data-time='time'

            :cpntStatus='button.status' 
            :cpntId='button.id' 
            :cpntTexto='button.texto' 
            :cpntClass='button.class'
            :cpntMostrar='button.mostrar'
            :cpntTabIndex='button.tabIndex'

            @onClickButton='button.onClick'
          ></RF-Button>
        </template>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .con-config-user-novo-alerta {
    padding: 10px;
    border: 1px solid red;
    border-radius: 5px;
    text-align: center;
  }

  .con-config-user-novo-alerta > button {
    margin: 0px 5px;
  }
</style>

<script>
  export default {
    props: {
      cpntFecharFormulario: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        config: {},
        formulario: {}
      }
    },
    mounted: function () {
      this.conectorConfigUsuarioFormIniciar()
    },
    methods: {
      conectorConfigUsuarioFormIniciar: function () {
        var self = this

        // SETA O STATUS GERAL
        self.statusGeral = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES DA INTEGRAÇÃO
        self.$store.state.GET_VALUE_LOCAL_STORAGE('CONECTOR', function (config) {
          // SETA O VALOR RECEBIDO
          self.config = config

          // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
          self.conectorConfigUsuarioFormFormularioIniciar()
        }, process.env.VUE_APP_CRI_KEY)
      },
      conectorConfigUsuarioFormFormularioIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: '',
          id: 'Conector-Config-Usuario-Form',
          field: {}
        }

        self.formulario.field.nome = {
          tipo: 'input',
          tamanho: 51,
          nome: 'Usuário',
          onChange: self.conectorConfigUsuarioFormOnChangeValue
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, [ 0 ], null, {
            env: self.conectorConfigUsuarioFormSalvar,
            can: self.cpntFecharFormulario
          }, function (buttons) {
            // SETA O TITULO DO BOTÃO
            buttons.env.texto = 'Aceito, inserir!'

            // CRIA OS BUTTONS DO FORMULARIO
            self.formulario.buttons = buttons

            // SETA O STATUS PARA O FORMULARIO
            self.statusGeral = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // SETA O CAMPO QUE RECEBE O FOCUS
            self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', 'nome')
          })
        })
      },
      conectorConfigUsuarioFormSalvar: function () {
        var self = this

        var formData = {}

        // SETA O NOME DO USUARIO PREENCHIDO NO CAMMPO
        formData.tipo = 'integracao'

        // SETA O NOME DO USUARIO PREENCHIDO NO CAMMPO
        formData.usuario = self.formulario.field.nome.value

        // PREENCHE O MESMO E-MAIL DO CADASTRO DA EMPRESA
        formData.email = self.$store.state.licenca.email

        // PREENCHE O MESMO E-MAIL DO CADASTRO DA EMPRESA
        formData.i_int_id = self.config.integracao.id

        // PREENCHE O MESMO E-MAIL DO CADASTRO DA EMPRESA
        formData.i_par_id = self.config.parceiro.id

        self.$store.state.comunicaAPI('/usuario', 'POST', formData, function (apiSuccess) {
          // CHAMA A FUNÇÃO PARA MOSTAR A MENSAGEM RECEBIDA DA API
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            self.cpntFecharFormulario(true)
          })
        }, function (apiError) {
          // SETA O STATUS PARA O FORMULARIO
          self.formulario.status = apiError

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, function (form) {
            // SETA OS CAMPOS COM OS ERROS
            self.formulario.field = form

            // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
            self.formulario.buttons.env.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          })
        })
      },
      conectorConfigUsuarioFormOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.substring((this.formulario.id.length + 1), id.length)

        // SETA O VALOR RECEBIDO
        this.formulario.field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>